/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProductResponseDTO { 
    id?: string;
    status?: string;
    machineName?: string;
    nickname?: string;
    machineType?: ProductResponseDTO.MachineTypeEnum;
    monitoringSupportStatus?: ProductResponseDTO.MonitoringSupportStatusEnum;
}
export namespace ProductResponseDTO {
    export const MachineTypeEnum = {
        IntegratedDirectDriveSeparator: 'INTEGRATED_DIRECT_DRIVE_SEPARATOR',
        Decanter: 'DECANTER',
        DirectDriveSeparator: 'DIRECT_DRIVE_SEPARATOR',
        FlatBeltSeparator: 'FLAT_BELT_SEPARATOR',
        GearboxSeparator: 'GEARBOX_SEPARATOR',
        CodestrykeSystems: 'CODESTRYKE_SYSTEMS'
    } as const;
    export type MachineTypeEnum = typeof MachineTypeEnum[keyof typeof MachineTypeEnum];
    export const MonitoringSupportStatusEnum = {
        HealthMonitorAvailable: 'HEALTH_MONITOR_AVAILABLE',
        CodestrykeAvailable: 'CODESTRYKE_AVAILABLE',
        NoCmAvailable: 'NO_CM_AVAILABLE'
    } as const;
    export type MonitoringSupportStatusEnum = typeof MonitoringSupportStatusEnum[keyof typeof MonitoringSupportStatusEnum];
}


